import axios_nomura from './axios-nomura.services';
import axios_cns_auth from './axios-cns-auth.services';

// export const signIn = async (credential) => {
//   const { username, password } = credential;
//   return await axios_nomura.post(`api/v1/login`, {
//     username: username,
//     password: password
//   });
// };
export const signIn = async (credential) => {
  return await axios_cns_auth.post(`api/v1/login`, credential);
};

export const send2FA = async ({ accessToken,...applicationId }) => {
  return await axios_cns_auth.post(`api/v1/login/two_factor/send_code`, applicationId, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
};

export const verify2FA = async (verifyCredential) => {
  return await axios_cns_auth.post(`api/v1/login/two_factor/verify`,verifyCredential);
};

export const verify2FACode = async (verifyCredential) => {
  return await axios_cns_auth.post(`api/v1/login/two_factor/verify_code`, verifyCredential, {
    headers: {
      Authorization: `Bearer ${verifyCredential.accessToken}`
    }
  });
};

export const verify2FAAuthenticator = async (verifyCredential) => {
  return await axios_cns_auth.post(`api/v1/login/two_factor/authenticator`,verifyCredential);
};

export const signInCredential = async () => {
  return await axios_nomura.get('api/v1/login/ad_test', { 
    headers: { 
      'Access-Control-Allow-Credentials': true
    }
  });
};

export const signInDSA = async (payload) => {
  const DSACode = payload !== '' ? payload.split('=')[1] : payload;
  return await axios_nomura.get(`api/v1/login/dsa${payload}`, { 
    headers: { 
      'Authorization': `Basic ${DSACode}`
    }
  });
};

export const signInSSO = async (payload) => {
  const SSOCode = payload !== '' ? payload.split('=')[1] : payload;
  return await axios_nomura.get(`api/v1/login/sso?p=${SSOCode}`);
};

export const fetchAccountList = async () => {
  return await axios_nomura.get(`api/v1/accounts`);
};

export const fetchAccountInfo = async (accountNumber) => {
  return await axios_nomura.get(`api/v1/accounts/${accountNumber}`);
};

export const fetchAccountName = async (accountNumber) => {
  return await axios_nomura.get(`api/v1/accounts/${accountNumber}/name`);
};

export const refreshWithCookies = async (cookies) => {
  return await axios_cns_auth.post(`api/v1/login/refresh_token`, cookies);
};

export const signOutWithCookies = async (cookies) => {
  return await axios_cns_auth.post(`api/v1/logout`, cookies);
};